var Kc2Report = (function () {

  var reportUrl,
    autoOpen;

  function init(option) {
    reportUrl = option.reportUrl;
    autoOpen = option.autoOpen;

    $(document)
      .ready(function () {
        $('.ibox-content').attr('style', 'height: ' + $(window).height() * 0.78 + 'px;');

          $('.btn.btn-sm.btn-default.m-r-md').closest('.m-b-xs').addClass('hidden');
          //$('#WorkListItemViewModelTable_wrapper button.btn.btn-default').addClass('hidden');

          if (autoOpen) {
            $('#option-show').modal();
          }
          $('#option-show').on('shown.bs.modal', function () {
            //$('.dataTables_wrapper .col-sm-6 .btn').hide();
          })
      })
      .on('click', '#report-generate', function () {
        $('#option-show').modal();
      })
    .on('click', '#report-save', function (e) {
      e.preventDefault();

      //getting data from our table
      var data_type = 'data:application/vnd.ms-excel';
      var table_div = $('#kc2-container');
      var table_html = table_div.outerHTML.replace(/ /g, '%20');

      var a = document.createElement('a');
      a.href = data_type + ', ' + table_html;
      a.download = 'exported_table_' + Math.floor((Math.random() * 9999999) + 1000000) + '.xls';
      a.click();
    });
  }

  function generate(option) {
    var idList = option.ids;
    if (idList.length > 0) {
      $.ajax({
        url: reportUrl,
        type: 'POST',
        dataType: 'html',
        data: {
          ids: idList
        }
      })
      .success(function (result) {
        $('.ibox-content').removeAttr('style');
        $('#kc2-container').html(result);

        $('#Kc2ReportTable').dataTable({
            //dom: 'Bfrtip',
            dom: "<'row'<'col-sm-6'><'col-sm-6 text-right top-paginate'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
          buttons: [],
          language: {
            url: Url.content('Content/Inspinia/plugins/dataTables/languages/Russian.json')
          },
          processing: false,
          searching: false,
          iDisplayLength: 45,
          columnDefs: [
            {
              orderable: false,
              targets: 0,
              visible: true
            },
            {
              orderable: false,
              targets: 1,
              visible: true
            },
            {
              orderable: false,
              targets: 2,
              visible: true
            },
            {
              orderable: false,
              targets: 3,
              visible: true
            },
            {
              orderable: false,
              targets: 4,
              visible: true
            },
            {
              orderable: false,
              targets: 5,
              visible: true
            },
            {
              orderable: false,
              targets: 6,
              visible: true
            },
            {
              orderable: false,
              targets: 7,
              visible: true
            },
            {
              orderable: false,
              targets: 8,
              visible: true
            }
          ],
          order: false
        });
      })
      .error(function (xhr, status, statusCode) {
        console.log(status + ': ' + statusCode);
      });
    } else {
      alert("Вы не выбрали ни одной работы. Отчет не будет сформирован.");
    }
  }

  return {
    init: init,
    generateReport: generate
  };
}())
